var _path, _path2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEvaluationIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0.5C24.5604 0.5 31.5 7.43959 31.5 16C31.5 24.5604 24.5604 31.5 16 31.5C7.43959 31.5 0.5 24.5604 0.5 16C0.5 7.43959 7.43959 0.5 16 0.5Z",
    fill: "#FFF2E8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 0.5C24.5604 0.5 31.5 7.43959 31.5 16C31.5 24.5604 24.5604 31.5 16 31.5C7.43959 31.5 0.5 24.5604 0.5 16C0.5 7.43959 7.43959 0.5 16 0.5Z",
    stroke: "#AD2102"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3802_13261)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5698 10.1451H19.5698V9.00223C19.5698 8.92366 19.5055 8.85938 19.4269 8.85938H18.4269C18.3483 8.85938 18.284 8.92366 18.284 9.00223V10.1451H13.7126V9.00223C13.7126 8.92366 13.6483 8.85938 13.5698 8.85938H12.5698C12.4912 8.85938 12.4269 8.92366 12.4269 9.00223V10.1451H9.4269C9.11083 10.1451 8.85547 10.4004 8.85547 10.7165V22.5737C8.85547 22.8897 9.11083 23.1451 9.4269 23.1451H22.5698C22.8858 23.1451 23.1412 22.8897 23.1412 22.5737V10.7165C23.1412 10.4004 22.8858 10.1451 22.5698 10.1451ZM21.8555 21.8594H10.1412V15.0737H21.8555V21.8594ZM10.1412 13.8594V11.4308H12.4269V12.2879C12.4269 12.3665 12.4912 12.4308 12.5698 12.4308H13.5698C13.6483 12.4308 13.7126 12.3665 13.7126 12.2879V11.4308H18.284V12.2879C18.284 12.3665 18.3483 12.4308 18.4269 12.4308H19.4269C19.5055 12.4308 19.5698 12.3665 19.5698 12.2879V11.4308H21.8555V13.8594H10.1412Z",
    fill: "#AD2102"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3802_13261"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvaluationIcon);
export default __webpack_public_path__ + "static/media/evaluationIcon.ef9f048ceb155727395817d5bd4555d6.svg";
export { ForwardRef as ReactComponent };